
  import { Component, Vue ,Inject} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import Switch from '@/components/switch.vue';
	import draggable from 'vuedraggable'
  import chooseCoupon from "@/components/chooseCoupon.vue"
  
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-switch':Switch,
      draggable,
      chooseCoupon
    }
  })

  export default class ProductList extends Vue {
    private chooseShow = false
    @Inject() information:any
    get value(){
      return this.information
    }
    
    @Inject() editinfo:any
    get editmsg(){
      return this.editinfo.msg
    }

    
    private getData(list){
      if(list.length>10){
        this.$message.error(`最多添加10张优惠券`)
        return
      }
      this.editmsg.list = list.map(v=>{
        // console.log(v.DerateMoney)
        if(v.DerateMoney==parseInt(v.DerateMoney)){
          v.beforePrice = v.DerateMoney
          v.afterPrice = null
        }else{
          [v.beforePrice,v.afterPrice] = String(v.DerateMoney).split('.')
        }
        if(v.ValidType==0){
          v.timelimit = v.StartTime + '~' + v.EndTime
        }else if(v.ValidType==1){
          v.timelimit = `领取后${v.ValidTime}天内`
        }else{
          v.timelimit = `领取后次日起${v.ValidTime}天内`
        }
        
        return v
      })
      this.$message.success('操作成功')
      this.chooseShow = false
    }
    private del(i){
      this.editmsg.list.splice(i,1)
    }
  }
